import React from "react";
import { PageMessage } from "@picklebet/ui";
import { SupportLink } from "@/features/shell/components/shared/SupportLink";

import { ReactComponent as ErrorIcon } from "assets/illustrations/account-error.svg";

/**
 * Shown for a non-GRANTED withdraw permission that `CheckPermissions` has no
 * dedicated screen for
 */
const WithdrawUnavailable = () => (
  <PageMessage
    image={<ErrorIcon />}
    title="Withdrawals are unavailable"
    subTitle="We can't process a withdrawal on your account right now."
  >
    <SupportLink openLiveChat type="button">
      Contact Support
    </SupportLink>
  </PageMessage>
);

export { WithdrawUnavailable };
